import { AdvicesSlider } from '@/features/advices-slider/ui/AdvicesSlider';

export { AdvicesSlider };
